/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_CONTAR_ARR,
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO,
    CASILLA_IMG,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {CategoryOutlined, CollectionsOutlined, ManageSearch} from "@mui/icons-material";
import {ESTADOSUSUARIOS} from "../../Constantes";
import Dialogo_Productos from "../Dialogos/Dialogo_Productos";
import {buscarPalabra} from "../../Modulo_Algolia/Funciones/buscarPalabra";
import Dialogo_Productos_SubCat from "../Dialogos/Dialogo_Productos_SubCat";
import Dialogo_Productos_Fotos from "../Dialogos/Dialogo_Productos_Fotos";

const Seccion_Productos = () => {
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente,
        numeroFilas,
    } = useObtenerColleccionTabla2025({coleccion: 'productos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Productos,
        titulo: 'Detalles del producto',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoSubCategorias, abrir: abrirSubCategorias} = useDialogo({
        Componente: Dialogo_Productos_SubCat,
        titulo: 'Sub categorias del producto',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoFotos, abrir: abrirFotos} = useDialogo({
        Componente: Dialogo_Productos_Fotos,
        titulo: 'Fotos de Producto',
        realizado: cargarNuevamente
    })


    const buscarProducto = async (palabra) => {
        let data = await buscarPalabra({palabra: palabra, coleccion: 'productos'})
        setData(data)
    }

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'subCategorias':
                abrirSubCategorias(data)
                break
            case 'fotos':
                abrirFotos(data)
                break
            default :
                abrir(data)
        }
    }


    return (

        <Grid2 container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoSubCategorias/>

                <DialogoFotos/>


                <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{marginTop: {xs: -18, sm: 0}}}>
                    <Tabla_Filtro
                        nombre={'Lista de productos'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        numeroFilas={numeroFilas}
                        funcionBuscar={buscarProducto}
                        //  botones={[]}
                    />
                </Grid2>

            </Grid2>

        </Grid2>
    )

}
export default Seccion_Productos

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },

]

const datosCabecera = [
    {
        nombre: 'Imagen',
        direccion: 'left',
        propiedad: 'img',
        tipo: CASILLA_IMG
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Marca',
        direccion: 'left',
        propiedad: 'marca',
        tipo: CASILLA_TEXTO
    },
    {
        nombre: 'Sub Categorias',
        direccion: 'right',
        propiedad: 'subCategorias',
        tipo: CASILLA_CONTAR_ARR

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSUSUARIOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'SubCategorias',
        id: 'subCategorias',
        icono: CategoryOutlined
    },
    {
        nombre: 'Fotos',
        id: 'fotos',
        icono: CollectionsOutlined
    },
]
